import Image1 from'../../assets/testimonial1.png';
import Image2 from'../../assets/testimonial2.png';
import Image3 from'../../assets/testimonial3.png';

export const Data = [
    {
      id: 1,
      image: Image1,
      title: "Jhon Doe",
      description:
      "I highly recommend Deepanshu as a valuable team member. Their exceptional work ethic, technical skills, and creativity make them a valuable asset to any project.",
    },
    {
      id: 2,
      image: Image2,
      title: "Harry Clinton",
      description:
      "I endorse Deepanshu as a standout teammate and classmate. Their technical skills, attention to detail, and collaborative approach make them a valuable asset to any team.",
    },
    {
      id: 3,
      image: Image3,
      title: "Sara Cill",
      description:
      "I highly recommend Deepanshu for any team. Their exceptional work ethic, technical ability, and collaborative mindset make them a valuable asset.",
    },
  ];